var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear / Notes / Document Text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 8.33329C2.5 5.1906 2.5 3.61925 3.47631 2.64294C4.45262 1.66663 6.02397 1.66663 9.16667 1.66663H10.8333C13.976 1.66663 15.5474 1.66663 16.5237 2.64294C17.5 3.61925 17.5 5.1906 17.5 8.33329V11.6666C17.5 14.8093 17.5 16.3807 16.5237 17.357C15.5474 18.3333 13.976 18.3333 10.8333 18.3333H9.16667C6.02397 18.3333 4.45262 18.3333 3.47631 17.357C2.5 16.3807 2.5 14.8093 2.5 11.6666V8.33329Z",
    stroke: "#28475C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66699 10H13.3337",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66699 6.66663H13.3337",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.66699 13.3334H10.8337",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/DocumentText.bceb8b0ae0b544c9355c9f6b61fc00ba.svg";
export { ForwardRef as ReactComponent };